(function ($) {

	var reviewContainer = $('.newsOverview');
	if (reviewContainer != null) {
		$('.cms').addClass("review-cms");
	}

})(jQuery, ResponsiveBootstrapToolkit);